export const FETCH_STATES = 'FETCH_STATES';
export const FETCH_STATES_SUCCESS = 'FETCH_STATES_SUCCESS';
export const FETCH_STATES_FAILURE = 'FETCH_STATES_FAILURE';
export const RESET_STATES = 'RESET_STATES';

export function fetchStates() {

    return {
        type: FETCH_STATES,
        payload: this.state.states
    };
}

export function fetchStatesSuccess(states) {
    return {
        type: FETCH_STATES_SUCCESS,
        payload: states
    };
}

export function fetchStatesFailure(error) {
    return {
        type: FETCH_STATES_FAILURE,
        payload: error
    };
}



/** WEBPACK FOOTER **
 ** ./src/actions/states.js
 **/